import { getVapidPublicKey, subscribePush, unsubscribePush } from 'src/api/push/pushApi';
import { getDestinoChatActivo } from 'src/utils/push-active';

export const pushSoportado = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const registrarServiceWorker = async () => {
  if (!pushSoportado()) return null;
  const registration = await navigator.serviceWorker.register('/sw.js');
  activarListenerPush();
  return registration;
};

const activarListenerPush = () => {
  if (window.__pushListenerActivo) return;
  window.__pushListenerActivo = true;

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type !== 'PUSH_QUERY') return;

    const payload = event.data.payload || {};
    const destino = getDestinoChatActivo();

    let mostrar = true;
    if (payload.tipo === 'chat' && destino) {
      const mismaOperacion = String(destino.operacion_id) === String(payload.operacion_id || '');
      const mismoInversionista = payload.inversionista_id
        ? String(destino.inversionista_id) === String(payload.inversionista_id)
        : true;
      mostrar = !(mismaOperacion && mismoInversionista);
    }

    event.ports?.[0]?.postMessage({ mostrar });
  });
};

export const registrarSuscripcionPush = async ({ pedirPermiso = true } = {}) => {
  if (!pushSoportado()) return null;
  if (Notification.permission === 'denied') return null;

  if (Notification.permission === 'default') {
    if (!pedirPermiso) return null;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;
  }

  const registration = await registrarServiceWorker();
  if (!registration) return null;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { data } = await getVapidPublicKey();
    const publicKey = data?.publicKey;
    if (!publicKey) return null;
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  await subscribePush(subscription.toJSON());
  return subscription;
};

export const eliminarSuscripcionPush = async () => {
  if (!pushSoportado()) return null;
  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration) return null;
  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    await unsubscribePush(subscription.endpoint).catch(() => {});
  }
  return subscription;
};
